import React, { useEffect, useState } from "react";
import "./LoadingScreen.css";

const tamilQuotes = [
  "மற்றவர்களின் நலனில் சொந்த நலனை காண்பதே அறம்.",
  "நற்குழுவில் பிறந்தால்தான் நல்லதோர் வாழ்க்கை பெறலாம்.",
  "நம்பிக்கையும் அன்பும் தான் ஒரு அறக்கட்டளையின் உயிர்.",
  "நீண்ட பயணம் ஒரு நல்ல செயலில் ஆரம்பம்!",
  "உதவுவது வாழ்வின் உயர்ந்த பண்பு."
];

const speakTamil = (text) => {
  const speak = () => {
    const voices = speechSynthesis.getVoices();
    const tamilVoice = voices.find(
      (voice) =>
        voice.lang === "ta-IN" ||
        voice.name.toLowerCase().includes("tamil")
    );

    const utterance = new SpeechSynthesisUtterance(text);
    utterance.lang = "ta-IN";
    utterance.rate = 0.9;
    utterance.pitch = 1.1;

    if (tamilVoice) {
      utterance.voice = tamilVoice;
    }

    speechSynthesis.cancel(); // Stop any previous speech
    speechSynthesis.speak(utterance);
  };

  if (speechSynthesis.getVoices().length === 0) {
    speechSynthesis.addEventListener("voiceschanged", speak, { once: true });
  } else {
    speak();
  }
};

const LoadingScreen = ({ onFinish }) => {
  const [quoteIndex, setQuoteIndex] = useState(0);
  const [progress, setProgress] = useState(0);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    speakTamil(tamilQuotes[0]);

    const quoteTimer = setInterval(() => {
      setQuoteIndex((prevIndex) => {
        const nextIndex = (prevIndex + 1) % tamilQuotes.length;
        speakTamil(tamilQuotes[nextIndex]);
        return nextIndex;
      });
    }, 3000);

    const progressTimer = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(progressTimer);
          clearInterval(quoteTimer);
          setFadeOut(true);
          speechSynthesis.cancel();
          setTimeout(() => {
            onFinish();
          }, 1000);
          return 100;
        }
        return prev + 2;
      });
    }, 100);

    return () => {
      clearInterval(quoteTimer);
      clearInterval(progressTimer);
      speechSynthesis.cancel();
    };
  }, [onFinish]);

  return (
    <div className={`loading-screen ${fadeOut ? "fade-out" : ""}`}>
      <img src="/logo1.jpg" alt="Trust Logo" className="logo pulse" />

      <div className="quote-box">
        <p className="quote-text">{tamilQuotes[quoteIndex]}</p>
      </div>

      <div className="progress-bar-container">
        <div className="progress-bar" style={{ width: `${progress}%` }}></div>
      </div>
    </div>
  );
};

export default LoadingScreen;
